import React from 'react';

const PrivacyPolicy: React.FC = () => {
  const contactInformation = "deckhopper@christinak.ca";

  return (
    <div className="bg-dark-blue text-gray-300 p-8 w-[100em] pb-10">
      <h1 className="text-3xl font-bold text-center mb-4">Privacy Policy for Deck Hopper</h1>
      <p className="text-center mb-4">
        This document outlines the privacy practices for Deck Hopper application available at <a href="https://play.google.com/store/apps/details?id=ca.christinak.DeckHopper" target="_blank" rel="noopener noreferrer" className="text-amber-500 underline">Google Play Store</a> and <a href="https://christinak.itch.io/deck-hopper" target="_blank" rel="noopener noreferrer" className="text-amber-500 underline">Itch.io</a>, as well as the website hosted at <a href="https://christinak.ca" target="_blank" rel="noopener noreferrer" className="text-amber-500 underline">christinak.ca</a>.
      </p>
      <hr className="border-t border-gray-500 my-4 mx-auto w-3/4" />

      {/* Contact Information */}
      <p className="mb-4 text-center">
        For privacy-related concerns, or to request deletion or modification of your data, contact us at: <a href={`mailto:${contactInformation}`} className="text-amber-500 underline">{contactInformation}</a>.
      </p>

      {/* Data Collection by Third-Party Services */}
      <h5 className="text-xl mb-2">Data Collection by Third-Party Services (Website):</h5>
      <p className="mb-4">
        Our website uses analytics services to collect information about user interactions. This includes:
        <ul>
          <li><strong>Google Analytics</strong> (via Google Tag Manager) to track website usage and improve performance. Privacy Policy: <a className="text-amber-500 underline" href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a>.</li>
          <li><strong>PostHog</strong> for analyzing user behavior and website performance. Privacy Policy: <a className="text-amber-500 underline" href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">PostHog Privacy Policy</a>.</li>
        </ul>
        These services collect anonymized data such as device information, IP address, and usage statistics to help us improve the website experience.
      </p>

      <h5 className="text-xl mb-2">Data Collection by Third-Party Services (App):</h5>
      <p className="mb-4">
        Our app relies on third-party services for certain functionalities, which involves the collection of personal data. This includes:
        <ul>
          <li><strong>Firebase</strong> for account management and data storage. Privacy Policy: <a className="text-amber-500 underline" href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase Privacy Policy</a>.</li>
          <li><strong>RevenueCat</strong> for managing subscriptions and in-app purchases. Privacy Policy: <a className="text-amber-500 underline" href="https://www.revenuecat.com/privacy" target="_blank" rel="noopener noreferrer">RevenueCat Privacy Policy</a>.</li>
          <li><strong>AdMob</strong> for serving ads. Privacy Policy: <a className="text-amber-500 underline" href="https://policies.google.com/technologies/partner-sites" target="_blank" rel="noopener noreferrer">AdMob Privacy Policy</a>.</li>
        </ul>
        These services collect data such as account details, device information, and usage statistics to enhance user experience, enable account login, and facilitate purchase sharing across different platforms.
      </p>

      {/* User Rights and Data Management */}
      <h5 className="text-xl mb-2">User Rights and Data Management:</h5>
      <p className="mb-4">
        Users have the right to access, rectify, or delete their data collected by these third-party services. For requests regarding data management, users can contact us directly or approach the respective third-party service providers.
      </p>

      {/* Compliance with Legal Requirements */}
      <h5 className="text-xl mb-2">Compliance with Legal Requirements:</h5>
      <p className="mb-4">
        We adhere to legal requirements concerning data collection, storage, and sharing by third-party services, including GDPR for EU citizens, offering rights such as data access, rectification, erasure, restriction, objection, and data portability.
      </p>
    </div>
  );
};

export default PrivacyPolicy;